function tucne(text, pattern) {
	var text_dia = normalize(text);
	pattern = normalize(pattern);
	pattern = pattern.toLowerCase();
	text_dia = text_dia.toLowerCase();
	var pattern_length = pattern.length;
	var pozice = 0;
	var offset_text = 0;
	while (text_dia.indexOf(pattern, pozice) != -1) {
		//alert('a');
		pozice = text_dia.indexOf(pattern, pozice);
		var pozice_text = pozice + offset_text;
		var pattern_text = text.substr(pozice_text, pattern_length);
		var re = new RegExp('('+pattern_text+')', 'i') ;
		var sub_text = text.substr(pozice_text);	
		text = text.substr(0,pozice_text) + sub_text.replace(re,"<strong>$1</strong>");
		pozice = pozice + pattern_length;		
		offset_text += 17;			
	}

	return text;
}	

function normalize( term ){
	var accentMap = settings.accentMap;
	var ret = "";
	for ( var i = 0; i < term.length; i++ ) {
		ret += accentMap[ term.charAt(i) ] || term.charAt(i);
	}
	return ret;
}

window.tucne     = tucne;
window.normalize = normalize;
